import { createTheme } from "@mui/material";
import {
	createPart,
	provideGlobalGridOptions,
	themeMaterial,
} from "ag-grid-community";

export const themeMESF = createTheme({
	palette: {
		mode: "light",
		primary: {
			main: "#3f51b5",
		},
		secondary: {
			main: "#f50057",
		},
	},
	typography: {
		// Modify base font size
		fontSize: 14,

		// Customize specific variants
		h6: {
			fontSize: "1.1rem",
			fontWeight: 500,
		},
		subtitle1: {
			fontSize: "0.875rem",
		},
		body1: {
			fontSize: "0.875rem",
		},
		body2: {
			fontSize: "0.875rem",
		},
	},
	components: {
		MuiTextField: {
			defaultProps: {
				size: "small",
				margin: "dense",
				fullWidth: true,
				variant: "outlined",
			},
		},
		MuiButton: {
			defaultProps: {
				size: "small",
			},
		},
		MuiListItemText: {
			styleOverrides: {
				primary: {
					fontSize: "0.875rem",
				},
			},
		},
		MuiListSubheader: {
			styleOverrides: {
				root: {
					fontSize: "0.875rem",
					fontWeight: 600,
				},
			},
		},
		MuiListItemIcon: {
			styleOverrides: {
				root: {
					minWidth: "40px",
				},
			},
		},
		MuiGrid2: {
			defaultProps: {
				size: "grow",
			},
		},
	},
});

const customPart = createPart({
	feature: "mesfGrid",
	css: `
    .ag-header-cell-label {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .ag-header-cell {
      padding: 0px !important;
      text-align: center !important;
      font-size: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .ag-header-group-cell-label {
      font-size: 13px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .ag-theme-material .ag-row:hover, & .ag-theme-material .ag-row.custom-selected {
      backgroundColor: #C8DEF7,
    }

    .ag-row-hover .buttons  {
      opacity: 1
    }
    .ag-row-focus .buttons  {
      opacity: 1
    }
    .ag-row-selected .buttons {
      opacity: 1
    }`,
});

export const themeDXT = themeMaterial.withPart(customPart);

provideGlobalGridOptions({
	theme: themeDXT,
});
